import { useEffect, useRef } from "react";
import { Briefcase, Compass, Eye, Flame, History, LayoutGrid, TrendingUp, type LucideIcon } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";

const TABS: { to: string; label: string; end?: boolean; Icon: LucideIcon }[] = [
  { to: "/",            label: "Watchlist",   end: true, Icon: Eye },
  { to: "/discover",    label: "Discover",               Icon: Compass },
  { to: "/trending",    label: "Trending",               Icon: Flame },
  { to: "/sectors",     label: "Sectors",                Icon: LayoutGrid },
  { to: "/smartmoney",  label: "Smart Money",            Icon: TrendingUp },
  { to: "/portfolio",   label: "Portfolio",              Icon: Briefcase },
  { to: "/hindsight",   label: "Hindsight",              Icon: History },
];

export default function TopNav() {
  const location = useLocation();
  const navRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = navRef.current?.querySelector<HTMLAnchorElement>('[aria-current="page"]');
    el?.scrollIntoView({ inline: "nearest", block: "nearest", behavior: "auto" });
  }, [location.pathname]);

  const link = (active: boolean) =>
    `relative inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap px-3 py-2 text-sm transition ${
      active ? "text-slate-100" : "text-slate-500 hover:text-slate-300"
    }`;
  const underline = (active: boolean) =>
    active
      ? "absolute inset-x-2 -bottom-px h-0.5 rounded-full bg-sky-400"
      : "hidden";

  return (
    <div className="relative mb-4">
      <nav
        ref={navRef}
        className="-mx-1 flex items-center gap-1 overflow-x-auto border-b border-slate-800 px-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        aria-label="Primary"
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            aria-label={t.label}
            className={({ isActive }) => link(isActive)}
          >
            {({ isActive }) => (
              <>
                <t.Icon className="h-4 w-4 shrink-0 sm:hidden" aria-hidden="true" />
                <span className={isActive ? "inline" : "hidden sm:inline"}>{t.label}</span>
                <span className={underline(isActive)} />
              </>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="pointer-events-none absolute inset-y-0 right-0 w-6 bg-gradient-to-l from-slate-950 to-transparent sm:hidden" />
    </div>
  );
}
